// extracted by mini-css-extract-plugin
export default {"wrapper":"cMVCzKr6mnT4hoPrm_sY","main":"A8ej2NCGQVbp0kH1uJXe","subtitle":"Hnxz3Vk0xj4SVPze4yHQ","subtitleDeprecating":"irty8Rnd9biH66y56Sm9"};